import { useAtomValue } from 'jotai'
import React from 'react'

import { useSurveyQueryQuestions } from '~/hooks/useSurveyQuery'

import {
  importanceQuestionIdAtom,
  liftSaQuestionIdAtom,
  npiDriverQuestionIdAtom,
} from '../atoms'

export const useCommonAnswerQuestions = () => {
  const allQuestions = useSurveyQueryQuestions()
  const npiDriverQuestionId = useAtomValue(npiDriverQuestionIdAtom)
  const importanceQuestionId = useAtomValue(importanceQuestionIdAtom)
  const liftSaQuestionId = useAtomValue(liftSaQuestionIdAtom)

  const npiDriverQuestions = React.useMemo(
    () =>
      allQuestions.filter(
        (q) =>
          q.question_id !== importanceQuestionId &&
          q.question_id !== liftSaQuestionId,
      ),
    [allQuestions, importanceQuestionId, liftSaQuestionId],
  )

  const importanceQuestions = React.useMemo(
    () =>
      allQuestions.filter(
        (q) =>
          q.question_id !== npiDriverQuestionId &&
          q.question_id !== liftSaQuestionId,
      ),
    [allQuestions, npiDriverQuestionId, liftSaQuestionId],
  )

  const liftSaQuestions = React.useMemo(
    () =>
      allQuestions.filter(
        (q) =>
          q.question_id !== npiDriverQuestionId &&
          q.question_id !== importanceQuestionId,
      ),
    [allQuestions, npiDriverQuestionId, importanceQuestionId],
  )

  return { npiDriverQuestions, importanceQuestions, liftSaQuestions }
}
